import type { ChangePasswordPayload, LoginHistoryEntry, UserProfile } from '@/libs/interfaces'

import { mockLoginHistory, mockUserProfile } from '../fixtures/account'
import { delay } from '../helpers'
import { createEntityStore } from '../store'

const profileStore = createEntityStore<UserProfile, 'userID'>([mockUserProfile], 'userID')
const loginHistoryStore = createEntityStore<LoginHistoryEntry, 'loginID'>(
  mockLoginHistory,
  'loginID',
)

export const accountApiMock = {
  getProfile: async (_orgID: string, userID: string): Promise<UserProfile> =>
    delay(profileStore.getById(userID) ?? mockUserProfile),

  updateProfile: async (userID: string, data: Partial<UserProfile>): Promise<UserProfile> => {
    const updated = profileStore.update(userID, data)
    return delay(updated ?? { ...mockUserProfile, ...data })
  },

  changePassword: async (_userID: string, _payload: ChangePasswordPayload): Promise<void> =>
    delay(undefined),

  getLoginHistory: async (_orgID: string, userID: string): Promise<LoginHistoryEntry[]> =>
    delay(loginHistoryStore.find((entry) => entry.userID === userID)),
}
